import * as S from "./style.ts";

interface IQuotes {
  mainQuote?: string;
  quotedPerson?: string;
  company?: string;
  link?: string;
}
interface IProps {
  quote: IQuotes;
}

const Quotes = ({ quote }: IProps) => {
  return (
    <S.QuoteWrapper>
      <S.Text>{quote?.mainQuote}"</S.Text>
      <S.Author>
        {quote?.quotedPerson}
        <S.Company>{quote?.company}</S.Company>
      </S.Author>
    </S.QuoteWrapper>
  );
};

export default Quotes;
